// extracted by mini-css-extract-plugin
export default {"BestRatedBooks":"BestRatedBooks_BestRatedBooks__Cae61","List":"BestRatedBooks_List__cc9B6"};